(function() {
  function preloadSwatchImages() {
    document.querySelectorAll('.product-card-swatch').forEach(function(swatch) {
      var srcset = swatch.dataset.srcset;
      if (!srcset) return;
      srcset.split(',').forEach(function(entry) {
        var src = entry.trim().split(' ')[0];
        if (!src) return;
        var img = new Image();
        img.src = src;
      });
    });
  }

  window.addEventListener('load', function() {
    setTimeout(preloadSwatchImages, 500);
  });

  var selectedColors = new WeakMap();
  var isTouchDevice = false;

  // Mobile: handle swatch tap via touchend
  document.addEventListener('touchend', function(e) {
    var swatch = e.target.closest('.product-card-swatch');
    if (!swatch) return;
    isTouchDevice = true;
    e.preventDefault();
    e.stopImmediatePropagation();
    updateSwatch(swatch);
  }, { capture: true, passive: false });

  // Desktop: handle swatch hover
  document.addEventListener('mouseenter', function(e) {
    if (isTouchDevice) return;
var swatch = e.target && e.target.closest && e.target.closest('.product-card-swatch');

    if (!swatch) return;
    updateSwatch(swatch);
  }, { capture: true });

  // Quick view click handler
  document.addEventListener('click', function(e) {
    var qv = e.target.closest('quick-view');
    if (!qv) return;
    var card = qv.closest('.product-card');
    if (!card) return;
    var color = selectedColors.get(card);
    if (!color) return;

    var drawer = document.getElementById('Product-Drawer');
    if (!drawer) return;
    var drawerContent = document.getElementById('Product-Drawer-Content');

    function applyColor() {
      var inputs = drawer.querySelectorAll('input[type="radio"]');
      var matched = false;
      inputs.forEach(function(input) {
        if (input.value.toLowerCase() === color.toLowerCase()) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          matched = true;
        }
      });
      return matched;
    }

    function waitForContentThenApply() {
      if (applyColor()) return;
      if (drawerContent) {
        var contentObserver = new MutationObserver(function() {
          if (applyColor()) contentObserver.disconnect();
        });
        contentObserver.observe(drawerContent, { childList: true, subtree: true });
        setTimeout(function() { contentObserver.disconnect(); }, 3000);
      }
    }

    if (drawer.classList.contains('active')) {
      waitForContentThenApply();
      return;
    }

    var drawerObserver = new MutationObserver(function() {
      if (drawer.classList.contains('active')) {
        drawerObserver.disconnect();
        waitForContentThenApply();
      }
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  });

  function updateSwatch(swatch) {
    var card = swatch.closest('.product-card');
    if (!card) return;
    card.querySelectorAll('.product-card-swatch').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    var colorName = swatch.querySelector('.visually-hidden');
    if (colorName) selectedColors.set(card, colorName.textContent.trim());

    var srcset = swatch.dataset.srcset;
    if (srcset) {
      var img = card.querySelector('.product-featured-image-link img');
      if (img) {
        img.style.opacity = '0.5';
        img.srcset = srcset;
        img.src = srcset.split(',')[0].trim().split(' ')[0];
        img.onload = function() { img.style.opacity = '1'; };
      }
    }
  }
})();